import BeatLoader from "react-spinners/BeatLoader";
import { css } from "@emotion/react";
import styled from "styled-components";

export default function DefaultLoader({ isLoading, color, cs = false }) {
  const override = css`
  display: block;
  margin: 0 auto;
  text-align: center;
  'margin-top: 20%;';
  ${cs ? cs : ""}
`;

  return (
    <ContainerWrapper>
      <BeatLoader
        color={color !== undefined ? color : "var(--primary)"}
        loading={isLoading}
        css={override}
        size={12}
      />
    </ContainerWrapper>
  );
}

const ContainerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
